var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 712 712",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312.264 82.915C323.611 86.8567 370.172 103.015 388.114 141.895C405.056 178.607 386.871 214.781 391.941 216.115C397.778 217.645 424.398 170.601 420.363 116.947C419.547 106.112 417.195 79.2304 399.059 52.8621C393.379 44.5991 386.285 34.3039 375.255 27.669C329.364 0.0766756 246.506 54.6249 250.637 70.294C252.686 78.0552 274.478 69.7921 312.264 82.915Z",
    fill: "url(#paint0_linear_221_27)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.48 210.275C188.561 202.369 225.773 169.964 268.263 173.795C308.4 177.42 330.485 211.329 334.179 207.57C338.42 203.261 311.166 156.573 262.887 133.264C253.149 128.564 228.783 117.155 196.971 119.75C187.001 120.558 174.58 121.574 163.343 127.854C116.611 153.964 122.218 253.318 137.783 257.552C145.498 259.67 149.277 236.583 179.48 210.275Z",
    fill: "url(#paint1_linear_221_27)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.908 389.455C220.629 377.605 211.293 329.03 235.841 293.995C259.035 260.907 299.307 258.642 297.917 253.549C296.32 247.711 242.434 248.078 198.19 278.412C189.256 284.532 167.243 300.031 153.58 328.993C149.301 338.065 143.963 349.376 143.756 362.304C142.902 416.007 231.38 460.81 242.812 449.39C248.517 443.697 230.49 428.873 222.908 389.455Z",
    fill: "url(#paint2_linear_221_27)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M399.128 441.261C387.781 437.319 341.221 421.16 323.279 382.282C306.337 345.569 324.522 309.396 319.452 308.061C313.613 306.531 286.994 353.576 291.027 407.229C291.844 418.063 294.196 444.946 312.334 471.315C318.013 479.576 325.107 489.872 336.138 496.507C382.028 524.1 464.886 469.552 460.754 453.882C458.694 446.121 436.901 454.384 399.128 441.261Z",
    fill: "url(#paint3_linear_221_27)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M531.916 313.902C522.836 321.81 485.623 354.213 443.134 350.382C402.997 346.757 380.911 312.85 377.218 316.607C372.976 320.916 400.23 367.605 448.509 390.913C458.248 395.613 482.613 407.023 514.426 404.428C524.395 403.62 536.815 402.604 548.053 396.324C594.785 370.213 589.178 270.86 573.613 266.625C565.885 264.507 562.107 287.595 531.916 313.902Z",
    fill: "url(#paint4_linear_221_27)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M488.474 134.721C490.753 146.571 500.089 195.145 475.542 230.181C452.347 263.27 412.075 265.534 413.464 270.627C415.061 276.465 468.948 276.098 513.192 245.764C522.126 239.644 544.139 224.146 557.802 195.183C562.081 186.111 567.419 174.8 567.626 161.873C568.479 108.169 480.002 63.3654 468.57 74.7868C462.877 80.4791 480.893 95.3036 488.474 134.721Z",
    fill: "url(#paint5_linear_221_27)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3182 691.497C60.061 691.497 51.6817 689.502 44.1803 685.512C36.6788 681.522 30.7734 675.776 26.464 668.275C22.1547 660.614 20 651.436 20 640.743C20 629.89 22.2345 620.632 26.7034 612.971C31.332 605.151 37.4768 599.165 45.1379 595.016C52.9586 590.706 61.5773 588.552 70.9941 588.552C79.932 588.552 87.7526 590.786 94.4561 595.255C101.319 599.724 106.347 605.23 109.539 611.774L108.102 615.365L110.018 592.382H126.776V689.343H108.342V662.289L110.975 667.556C110.018 669.791 108.342 672.265 105.948 674.978C103.713 677.691 100.761 680.325 97.0896 682.879C93.4186 685.432 89.1891 687.507 84.4009 689.103C79.7724 690.699 74.7448 691.497 69.3182 691.497ZM73.867 676.415C79.932 676.415 85.3586 675.218 90.1467 672.823C95.0945 670.429 99.1645 667.078 102.357 662.768C105.549 658.459 107.544 653.352 108.342 647.446V630.209C107.065 625.101 104.751 620.553 101.399 616.562C98.0472 612.572 93.9773 609.46 89.1891 607.225C84.4009 604.991 79.1339 603.874 73.3881 603.874C67.0039 603.874 61.0985 605.39 55.6719 608.423C50.4049 611.455 46.1754 615.685 42.9832 621.111C39.9507 626.378 38.4345 632.603 38.4345 639.785C38.4345 646.648 40.0305 652.873 43.2226 658.459C46.4147 663.886 50.7241 668.275 56.1507 671.626C61.5773 674.819 67.4827 676.415 73.867 676.415ZM178.05 691.258C171.665 691.258 165.281 690.141 158.897 687.906C152.514 685.512 147.247 681.921 143.097 677.133L151.237 666.359C154.908 670.03 158.897 672.903 163.206 674.978C167.675 676.893 172.224 677.851 176.853 677.851C180.204 677.851 183.317 677.452 186.19 676.654C189.062 675.696 191.377 674.18 193.132 672.105C195.048 670.03 196.005 667.157 196.005 663.487C196.005 659.656 194.808 656.703 192.414 654.628C190.02 652.394 186.988 650.638 183.317 649.361C179.805 647.925 176.055 646.568 172.064 645.291C164.244 642.897 158.179 639.466 153.87 634.997C149.561 630.528 147.406 624.782 147.406 617.759C147.406 612.652 148.683 607.944 151.237 603.634C153.791 599.325 157.46 595.893 162.249 593.34C167.196 590.626 173.102 589.27 179.965 589.27C186.03 589.27 191.696 590.148 196.963 591.903C202.23 593.499 207.098 596.213 211.567 600.043L204.145 611.535C201.432 608.502 198 606.268 193.851 604.831C189.86 603.395 186.269 602.597 183.077 602.437C180.364 602.437 177.651 602.916 174.937 603.874C172.224 604.831 169.99 606.268 168.234 608.183C166.638 610.098 165.84 612.492 165.84 615.365C165.68 618.877 166.718 621.67 168.952 623.745C171.187 625.82 173.98 627.575 177.331 629.012C180.843 630.289 184.434 631.565 188.105 632.842C192.893 634.279 197.202 636.114 201.033 638.349C205.023 640.583 208.215 643.456 210.609 646.967C213.003 650.319 214.2 654.628 214.2 659.895C214.2 665.641 212.844 670.908 210.13 675.696C207.577 680.485 203.587 684.315 198.16 687.188C192.893 689.901 186.19 691.258 178.05 691.258ZM283.204 690.474C272.514 690.474 263.083 688.274 254.911 683.873C246.861 679.471 240.575 673.435 236.048 665.765C231.645 658.094 229.446 649.291 229.446 639.357C229.446 629.423 231.583 620.62 235.86 612.95C240.26 605.279 246.234 599.306 253.779 595.03C261.447 590.629 270.062 588.428 279.621 588.428C289.302 588.428 297.852 590.566 305.274 594.842C312.692 599.117 318.477 605.153 322.627 612.95C326.9 620.62 329.04 629.611 329.04 639.923C329.04 640.677 328.975 641.558 328.852 642.564C328.852 643.57 328.786 644.513 328.663 645.393H243.593V632.378H319.232L311.875 636.905C311.999 630.492 310.678 624.77 307.914 619.74C305.147 614.71 301.312 610.812 296.408 608.045C291.627 605.153 286.034 603.707 279.621 603.707C273.331 603.707 267.737 605.153 262.833 608.045C257.929 610.812 254.091 614.773 251.327 619.929C248.559 624.959 247.177 630.743 247.177 637.282V640.3C247.177 646.965 248.686 652.938 251.704 658.22C254.845 663.375 259.184 667.399 264.719 670.292C270.251 673.184 276.603 674.63 283.77 674.63C289.679 674.63 295.023 673.624 299.803 671.612C304.708 669.6 308.981 666.582 312.63 662.558L322.627 674.253C318.1 679.534 312.441 683.558 305.651 686.325C298.984 689.091 291.504 690.474 283.204 690.474ZM362.09 592.382L363.765 618.238L362.568 613.929C365.601 606.268 370.708 600.203 377.891 595.734C385.232 591.105 393.612 588.791 403.029 588.791C412.126 588.791 419.548 591.504 425.293 596.931C431.199 602.358 434.231 609.38 434.391 617.999V689.343H415.957V623.984C415.797 618.398 414.121 613.849 410.929 610.338C407.737 606.667 402.869 604.752 396.325 604.592C390.42 604.592 384.993 606.188 380.045 609.38C375.097 612.413 371.187 616.722 368.314 622.308C365.441 627.735 364.005 634.119 364.005 641.461V689.343H345.81V592.382H362.09ZM457.875 592.382H476.07V689.343H457.875V592.382ZM455.96 556.95C455.96 553.917 457.157 551.363 459.551 549.289C462.104 547.214 464.818 546.176 467.691 546.176C470.563 546.176 473.117 547.214 475.352 549.289C477.586 551.363 478.703 553.917 478.703 556.95C478.703 560.142 477.586 562.775 475.352 564.85C473.117 566.925 470.563 567.962 467.691 567.962C464.818 567.962 462.104 566.925 459.551 564.85C457.157 562.616 455.96 559.982 455.96 556.95ZM581.682 680.245C577.372 683.756 572.265 686.55 566.36 688.624C560.454 690.54 554.389 691.497 548.165 691.497C537.79 691.497 528.613 689.422 520.633 685.273C512.812 680.963 506.667 674.978 502.198 667.317C497.729 659.656 495.495 650.798 495.495 640.743C495.495 630.528 497.809 621.67 502.438 614.168C507.226 606.507 513.45 600.602 521.111 596.452C528.932 592.143 537.391 589.988 546.489 589.988C553.831 589.988 560.534 591.026 566.599 593.1C572.664 595.175 577.851 598.048 582.161 601.719L573.063 613.929C570.031 611.535 566.36 609.46 562.05 607.704C557.741 605.789 553.033 604.831 547.925 604.831C541.701 604.831 535.955 606.427 530.688 609.62C525.421 612.812 521.271 617.121 518.238 622.548C515.206 627.974 513.69 634.039 513.69 640.743C513.69 647.287 515.206 653.272 518.238 658.698C521.431 664.125 525.74 668.434 531.167 671.626C536.593 674.819 542.738 676.415 549.601 676.415C554.07 676.415 558.22 675.776 562.05 674.499C565.881 673.063 569.312 671.148 572.345 668.754L581.682 680.245ZM585.817 640.024C585.817 630.448 588.052 621.75 592.52 613.929C597.149 606.108 603.533 599.963 611.673 595.494C619.813 590.866 628.911 588.552 638.966 588.552C649.34 588.552 658.438 590.866 666.258 595.494C674.239 599.963 680.383 606.108 684.693 613.929C689.162 621.75 691.396 630.368 691.396 639.785C691.396 649.521 689.162 658.299 684.693 666.12C680.383 673.941 674.239 680.165 666.258 684.794C658.278 689.263 649.101 691.497 638.726 691.497C628.671 691.497 619.653 689.343 611.673 685.033C603.693 680.724 597.388 674.739 592.76 667.078C588.131 659.257 585.817 650.239 585.817 640.024ZM604.251 640.264C604.251 646.967 605.768 653.112 608.8 658.698C611.833 664.125 615.903 668.434 621.01 671.626C626.277 674.819 632.103 676.415 638.487 676.415C645.031 676.415 650.936 674.819 656.203 671.626C661.47 668.434 665.54 664.125 668.413 658.698C671.446 653.112 672.962 646.967 672.962 640.264C672.962 633.56 671.446 627.495 668.413 622.069C665.54 616.483 661.47 612.093 656.203 608.901C650.936 605.55 645.111 603.874 638.726 603.874C632.023 603.874 626.038 605.55 620.771 608.901C615.663 612.253 611.593 616.722 608.561 622.308C605.688 627.735 604.251 633.72 604.251 640.264Z",
    fill: "url(#paint6_linear_221_27)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_221_27",
    x1: 317.001,
    y1: 50.4286,
    x2: 396.059,
    y2: 163.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0657,
    stopColor: "#B6CE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#91C24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    stopColor: "#75B957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    stopColor: "#69B759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39AF75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_221_27",
    x1: 153.836,
    y1: 189.919,
    x2: 291.08,
    y2: 178.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0657,
    stopColor: "#B6CE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#91C24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    stopColor: "#75B957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    stopColor: "#69B759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39AF75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_221_27",
    x1: 192.53,
    y1: 401.576,
    x2: 251.583,
    y2: 276.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3996B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5236,
    stopColor: "#61BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7048,
    stopColor: "#4DB9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26B3AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_221_27",
    x1: 394.382,
    y1: 473.742,
    x2: 315.323,
    y2: 360.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#267FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#3A92B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2966,
    stopColor: "#54AAC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4445,
    stopColor: "#65BAC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    stopColor: "#6BC0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB2A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_221_27",
    x1: 557.549,
    y1: 334.251,
    x2: 420.305,
    y2: 345.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#267FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00783188,
    stopColor: "#2881B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2379,
    stopColor: "#4CA2BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4129,
    stopColor: "#63B8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5111,
    stopColor: "#6BC0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6801,
    stopColor: "#5CBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9923,
    stopColor: "#22B2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB2A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_221_27",
    x1: 518.856,
    y1: 122.593,
    x2: 459.803,
    y2: 247.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0657,
    stopColor: "#B6CE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#91C24F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    stopColor: "#75B957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    stopColor: "#69B759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39AF75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_221_27",
    x1: 8.74779,
    y1: 633.435,
    x2: 712.464,
    y2: 633.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#63B55E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#37AF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#1DB1A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#66BBC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#267FB0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.57c9a0f83f2e05ab3f3e4efcd6ee1efb.svg";
export { ForwardRef as ReactComponent };